import { AccountResponse } from '@/account/Interfaces';
import { NewSession } from '@/auth/index';

export type isProhibitedSessionProps = {
  setSession: (session: NewSession) => void;
  redirect: (path: string) => void;
  accountInfo: AccountResponse | undefined;
  link?: string;
};

export function removeSpecialChars(name = '') {
  return name
    .toLowerCase()
    .replace(/[^A-Za-z0-9 ]/g, '')
    .trim();
}
